import { render, staticRenderFns } from "./DeliverablesView.vue?vue&type=template&id=5a4b496d&scoped=true&"
import script from "./DeliverablesView.vue?vue&type=script&lang=js&"
export * from "./DeliverablesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b496d",
  null
  
)

export default component.exports